import type * as GraphQLTypes from '../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePartnerMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreatePartnerInput;
}>;


export type CreatePartnerMutationResult = (
  { __typename?: 'Mutation' }
  & { createPartner?: GraphQLTypes.Maybe<(
    { __typename?: 'Partner' }
    & Pick<GraphQLTypes.Partner, 'id' | 'name'>
  )> }
);


export const CreatePartnerDocument = /*#__PURE__*/ gql`
    mutation createPartner($input: CreatePartnerInput!) {
  createPartner(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutationResult, CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerMutationResult, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;